import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { addDays } from "date-fns/addDays";
import { create } from "zustand";

interface IsRetailerCreatedWithinLast30Days {
  isRetailerCreatedWithinLast30Days: boolean;
  setIsRetailerCreatedWithinLast30Days: (retailer: Partial<IRetailer>) => void;
}

export const useZustandIsRetailerCreatedWithinLast30Days =
  create<IsRetailerCreatedWithinLast30Days>((set) => ({
    isRetailerCreatedWithinLast30Days: false,
    setIsRetailerCreatedWithinLast30Days: (retailer) => {
      if (!retailer?.created_at) {
        set({ isRetailerCreatedWithinLast30Days: false });
        return;
      }

      set({
        isRetailerCreatedWithinLast30Days:
          addDays(new Date(retailer.created_at), 31) > new Date(),
      });
    },
  }));

const useIsRetailerCreatedWithinLast30DaysControl = () => {
  const { isRetailerCreatedWithinLast30Days } = useRetailerStore([
    "isRetailerCreatedWithinLast30Days",
  ]);
  return { isRetailerCreatedWithinLast30Days };
};

export const useIsRetailerCreatedWithinLast30Days = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandIsRetailerCreatedWithinLast30Days();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useIsRetailerCreatedWithinLast30DaysControl();
};
